import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

const ComponentStyles = (theme: Theme) =>
    createStyles({
        thumbnailContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            padding: '5px',
            overflowY: 'auto',
        },
        drawer: {
            display: 'flex',
            width: theme.rightDrawerWidth,
            height: `calc(100% - ${theme.footerHeight}px)`,
        }
    });

export default ComponentStyles;